export default __webpack_public_path__ + "static/media/token.ad26e701.png";